<div class="h-100">
  <finxone-web-frontend-accounts-listing
    class="h-100"
    [widgetConfigData]="widgetConfig"
    [contentStyle]="contentStyle"
    [textContentStyle]="textContentStyle"
    [searchIconStyle]="searchIconStyle"
    [accountsInfo]="accountsInfo"
    [context]="context"
    [currencies]="currencies"
    [countries]="countries"
    (scrolled)="handleChildComponentScroll()"
    [contextSwitch]="contextSwitch"
    [navigateToUrl]="navigateToUrl"
    [accountContextStatusList]="accountContextStatusList"
    (tablePaginationAndSearch)="handleTablePaginationClickAndSearch($event)"
  ></finxone-web-frontend-accounts-listing>
</div>
